import React, { Fragment } from 'react'
import { DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Divider } from '@material-ui/core'

export const OverLimit = ({ onClose, onSubmit }) => (
  <Fragment>
    <DialogTitle>Недостатня к-ть вільних місць!</DialogTitle>
    <Divider />
    <DialogContent>
      <DialogContentText>
        Ви бажаєте забронювати поза лімітом?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color='secondary'>
        Ні
      </Button>
      <Button onClick={onSubmit} color='primary'>
        Так
      </Button>
    </DialogActions>
  </Fragment>
)



// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/OverLimit/OverLimit.js